import { render, staticRenderFns } from "./client-quotation-preview.vue?vue&type=template&id=5ae3be90"
import script from "./client-quotation-preview.vue?vue&type=script&lang=js"
export * from "./client-quotation-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports